import { createAsyncThunk } from '@reduxjs/toolkit'
import { FAQ_URLS } from '../../../../configs/api'
import { AxiosService } from '../../../../services/api'
import { createThunkName } from '../../../../utils/createThunkname'
import { CreateOrUpdateFAQDto, GetAllFAQsResponse } from './types'

const PREFIX = 'faq'

export const FaqService = {
  getFAQsAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'getFAQs'), async () => {
    try {
      const result = await AxiosService.get<GetAllFAQsResponse>(FAQ_URLS.getAllFAQs)
      return result.data
    } catch (error) {
      throw error
    }
  }),
  createOrUpdateFAQsAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'createOrUpdateFAQs'),
    async (dto: CreateOrUpdateFAQDto) => {
      try {
        await AxiosService.post(FAQ_URLS.createOrUpdateFAQs, dto)
      } catch (error) {
        throw error
      }
    }
  )
}
